export const provinceBasedFieldLabels : any = {
    'get' :  (key: string, provinceCode: string) => {
        if(provinceBasedFieldLabels[key]) {
            if(provinceBasedFieldLabels[key][provinceCode]){
                return provinceBasedFieldLabels[key][provinceCode];
            }
            return provinceBasedFieldLabels[key]['DEFAULT'];
        } else {
            return '';
        }

    },

    'cirfMatterData.capacity' : {
        'ON' : 'Capacity',
        'AB' : 'Tenure',
        'MB' : 'Tenure',
        'SK' : 'Tenure',
        'NB' : 'Tenure',
    },

    'matterInfo.lawClerk' : {
        'DEFAULT' :  'Legal Assistant',
        'ON' :  'Law Clerk',
        'NB' : 'Law Clerk',
        'NS' : 'Paralegal',
        'BC' : 'Conveyancer'
    },
};